import { useEffect } from 'react';
import { setHoneypotValue, resetHoneypotValue } from '@/lib/form-token-client';

/**
 * Honeypot field for auth forms. Bots that auto-fill every input on a page
 * populate this; real users never see or focus it (off-screen + tabIndex=-1
 * + aria-hidden). Whatever value lands here is sent as X-Honeypot to the
 * backend, where the bot-fallback middleware rejects any non-empty value.
 *
 * Render this inside the form. Reset on unmount so a refilled honeypot
 * doesn't leak across page navigations.
 */
export function Honeypot() {
  useEffect(() => {
    resetHoneypotValue();
    return () => resetHoneypotValue();
  }, []);

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
    >
      <label htmlFor="company_url">Company URL (leave blank)</label>
      <input
        type="text"
        id="company_url"
        name="company_url"
        autoComplete="off"
        tabIndex={-1}
        onChange={(e) => setHoneypotValue(e.target.value)}
      />
    </div>
  );
}
